import UltMeta, { Meta } from "./UltMeta/index";

/** TODO: 3826 查船迁移兼容：港口层级类型，待港口能力接入后替换为真实字典。 */
class PortType extends UltMeta {
    HARBOR = new Meta(1, "港区");
    PORT = new Meta(2, "码头");
    BERTH = new Meta(3, "泊位");
}

/** TODO: 3826 查船迁移兼容：泊位类型占位。 */
class PortBerthType extends UltMeta {
    UNKNOWN = new Meta("", "--");
}

/** TODO: 3826 查船迁移兼容：装卸属性占位。 */
class PortHandlingAttribute extends UltMeta {
    UNKNOWN = new Meta("", "--");
}

/** TODO: 3826 查船迁移兼容：港口货物类型占位。 */
class PortGoodsType extends UltMeta {
    UNKNOWN = new Meta("", "--");
}

export const TYPE = new PortType();
export const PORT_TYPE = new PortType();
export const PORT_BERTH_TYPE = new PortBerthType();
export const PORT_HANDLING_ATTRIBUTE = new PortHandlingAttribute();
export const PORT_GOODS_TYPE = new PortGoodsType();
